import { Button, Icon, IconButton, Table, TableBody, TableCell, TableHead, TableRow, Tooltip } from '@mui/material';
import { Styled } from './index.styles';
import { Add } from '@mui/icons-material';
import { routesPaths } from 'config/routes';
import i18n from 'assets/i18n';
import { useEffect, useState } from 'react';
import loginService from 'services/login/index.api';
import { t } from 'i18next';
import SEO from 'components/seo';
import { Loading } from 'components/loading';

const MyBillsPage = () => {
    const [list, setList] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const handleData = async () => {
        setIsLoading(true);

        try {
            await loginService
                .BillingInfo()
                .then((res: any) => {
                    const data = res.data;
                    if (data.success) {
                        data.invoices_info && setList(data.invoices_info);
                        setIsLoading(false);
                    }
                })
                .catch((err: any) => {
                    console.log('err:', err);
                    setIsLoading(false);
                });
        } catch (err) {
            console.log('err:', err);
            setIsLoading(false);
        }
    };
    const deleteBiiling = async (guid: string) => {
        if (confirm(`${t('account.mybill.text.confirm')}`)) {
            try {
                await loginService
                    .DeleteBiiling({ guid: guid })
                    .then((res: any) => {
                        const data = res.data;
                        if (data.success) {
                            handleData();
                        }
                    })
                    .catch((err: any) => {
                        console.log('err:', err);
                    });
            } catch (err) {
                console.log('err:', err);
            }
        }
    };

    useEffect(() => {
        handleData();
    }, []);

    return (
        <Styled>
            <>
                <SEO title={t('account.mybill.text.title')} noindex={true} />

                <div className="page-head">
                    <div className="title">{t('account.mybill.text.title')}</div>

                    <Button
                        color="primary"
                        variant="contained"
                        size="small"
                        startIcon={<Add />}
                        href={routesPaths[i18n.language].accountBillsAdd}
                    >
                        {t('button.addBill')}
                    </Button>
                </div>
                <div className="page-content">
                    <Table size="small" className="custom-table">
                        <TableHead>
                            <TableRow>
                                <TableCell>{t('account.mybill.text.type')}</TableCell>
                                <TableCell>{t('account.mybill.text.name')}</TableCell>
                                <TableCell>{t('account.mybill.text.no')}</TableCell>
                                <TableCell>{t('account.mybill.text.adress')}</TableCell>
                                <TableCell></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {!isLoading && list.length > 0 ? (
                                list?.map((row: any, index: number) => (
                                    <TableRow key={index}>
                                        <TableCell>
                                            {row.invoice_type === 'Individual'
                                                ? t('flight.passenger.billInfo.individual')
                                                : row.invoice_type === 'Institutional'
                                                ? t('flight.passenger.billInfo.corporate')
                                                : ''}
                                        </TableCell>
                                        <TableCell>
                                            {row.invoice_type === 'Individual' ? row.full_name : row.company_name}
                                        </TableCell>
                                        <TableCell>
                                            {row.invoice_type === 'Individual' ? row.identnumber : row.id_tax_number}
                                        </TableCell>
                                        <TableCell>
                                            {row.invoice_address} {row.district}
                                            {row.city ? '/' + row.city : ''}
                                            {row.country ? '-' + t(`countries.${row.country}`) : ''}
                                        </TableCell>
                                        <TableCell>
                                            <div className="buttons">
                                                <Tooltip
                                                    title={t('account.mybill.text.edit')}
                                                    arrow
                                                    componentsProps={{
                                                        tooltip: {
                                                            className: 'primary',
                                                        },
                                                    }}
                                                >
                                                    <IconButton
                                                        href={
                                                            routesPaths[i18n.language].accountBillsEdit + '/' + row.guid
                                                        }
                                                    >
                                                        <Icon>edit</Icon>
                                                    </IconButton>
                                                </Tooltip>
                                                <Tooltip
                                                    title={t('account.mybill.text.delete')}
                                                    arrow
                                                    componentsProps={{
                                                        tooltip: {
                                                            className: 'primary',
                                                        },
                                                    }}
                                                >
                                                    <IconButton
                                                        onClick={() => {
                                                            deleteBiiling(row.guid);
                                                        }}
                                                    >
                                                        <Icon>delete</Icon>
                                                    </IconButton>
                                                </Tooltip>
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                ))
                            ) : isLoading ? (
                                <tr>
                                    <td colSpan={4} className="no-data">
                                        <div className="box">
                                            <Loading type="box" />
                                        </div>
                                    </td>
                                </tr>
                            ) : (
                                <tr>
                                    <td colSpan={5} className="no-data">
                                        <div className="box">
                                            <div className="icon">
                                                <Icon>article</Icon>
                                            </div>
                                            {t('account.mybill.text.nofound')}
                                        </div>
                                    </td>
                                </tr>
                            )}
                        </TableBody>
                    </Table>
                </div>
            </>
        </Styled>
    );
};
export default MyBillsPage;
